import React from 'react'

import { Space, Select } from 'antd'

const lqaTypes = [
  { value: 'Internal', label: 'Internal' },
  { value: 'Client', label: 'Client' },
  { value: 'External', label: 'External' }
]

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const Filters = (props) => {
  const { filters } = props
  const lqaType = filters ? (filters.lqaType ? filters.lqaType : undefined) : undefined

  return (
    <Space size='small'>
      <Select
        placeholder='Type'
        allowClear
        size='small'
        showSearch
        options={lqaTypes}
        filterOption={_filter}
        style={{ minWidth: '150px' }}
        value={lqaType}
        onChange={(e) => {
          props.onUpdateFilters({ lqaType: e ? e : undefined })
        }}
      />
    </Space>
  )
}

export default Filters
